import { QuestionSetSummaryColumn } from './components/QuestionSetSummaryOverlay';

// Shared column definitions so any consumer opening the reusable QuestionSetSummaryOverlay
// presents the same set of columns. Row data is fetched from the GetQuestionSetSummary API keyed by assessmentId/revisionId.
export const QUESTION_SET_SUMMARY_COLUMNS: QuestionSetSummaryColumn[] = [
    { key: 'questionSetName', label: 'QUESTION SET NAME' },
    { key: 'questionSetId', label: 'QUESTION SET ID' },
    { key: 'questionSetCreatedTimestamp', label: 'QUESTION SET CREATED' },
    { key: 'questionSetLastEditTimestamp', label: 'QUESTION SET LAST EDIT' },
    { key: 'questionSetStatus', label: 'QUESTION SET STATUS' },
    { key: 'questionSetRevisionId', label: 'QUESTION SET REVISION ID' },
    { key: 'contentBlockName', label: 'CONTENT BLOCK NAME' },
    { key: 'contentBlockId', label: 'CONTENT BLOCK ID' },
    { key: 'contentBlockCreated', label: 'CONTENT BLOCK CREATED' },
    { key: 'contentBlockLastEdit', label: 'CONTENT BLOCK LAST EDIT' },
    { key: 'contentBlockStatus', label: 'CONTENT BLOCK STATUS' },
    { key: 'contentBlockRevisionId', label: 'CONTENT BLOCK REVISION ID' },
    { key: 'questionName', label: 'QUESTION NAME' },
    { key: 'questionId', label: 'QUESTION ID' },
    { key: 'questionType', label: 'QUESTION TYPE' },
    { key: 'questionCreatedTimestamp', label: 'QUESTION CREATED' },
    { key: 'questionLastEditTimestamp', label: 'QUESTION LAST EDIT' },
    { key: 'questionStatus', label: 'QUESTION STATUS' },
    { key: 'questionRevisionId', label: 'QUESTION REVISION ID' },
    { key: 'authorName', label: 'AUTHOR NAME' },
    { key: 'authorId', label: 'AUTHOR ID' },
];

// MPP names are snake_case; the GetQuestionSetSummary API returns camelCase fields.
/* eslint-disable @typescript-eslint/camelcase */
export const QUESTION_SET_SUMMARY_MPP_COLUMN_KEYS: Record<string, string> = {
    question_set_name: 'questionSetName',
    question_set_id: 'questionSetId',
    question_set_created_timestamp: 'questionSetCreatedTimestamp',
    question_set_last_edit_timestamp: 'questionSetLastEditTimestamp',
    question_set_status: 'questionSetStatus',
    question_set_revision_id: 'questionSetRevisionId',
    section_name: 'contentBlockName',
    section_id: 'contentBlockId',
    section_created: 'contentBlockCreated',
    section_last_edit: 'contentBlockLastEdit',
    section_status: 'contentBlockStatus',
    section_revision_id: 'contentBlockRevisionId',
    question_name: 'questionName',
    question_id: 'questionId',
    question_type: 'questionType',
    question_created_timestamp: 'questionCreatedTimestamp',
    question_last_edit_timestamp: 'questionLastEditTimestamp',
    question_status: 'questionStatus',
    question_revision_id: 'questionRevisionId',
    author_name: 'authorName',
    author_id: 'authorId',
};
/* eslint-enable @typescript-eslint/camelcase */

export const getConfiguredQuestionSetSummaryColumns = (
    mppColumns: Record<string, boolean>
): QuestionSetSummaryColumn[] => Object.keys(mppColumns)
    .filter((key) => mppColumns[key] === true)
    .map((key) => QUESTION_SET_SUMMARY_COLUMNS.find(
        (column) => column.key === QUESTION_SET_SUMMARY_MPP_COLUMN_KEYS[key]
    ))
    .filter((column): column is QuestionSetSummaryColumn => column !== undefined);
